// ==============================|| OVERRIDES - BUTTON BASE ||============================== //

import BbLinkBehavior from "@/components/building-blocks/controls/BbLinkBehavior"

export default function ButtonBase() {
    return {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: false,
                LinkComponent: BbLinkBehavior,
            },
        },
    }
}
